import { render } from "./robDetail.vue?vue&type=template&id=86d86526&scoped=true"
import script from "./robDetail.vue?vue&type=script&lang=js"
export * from "./robDetail.vue?vue&type=script&lang=js"

import "./robDetail.vue?vue&type=style&index=0&id=86d86526&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86d86526"],['__file',"src/views/my/robDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "86d86526"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('86d86526', __exports__)) {
    console.log('reload')
    api.reload('86d86526', __exports__)
  }
  
  module.hot.accept("./robDetail.vue?vue&type=template&id=86d86526&scoped=true", () => {
    console.log('re-render')
    api.rerender('86d86526', render)
  })

}


export default __exports__